export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"},{"hid":"description","name":"description","content":"MixCare Health"},{"name":"keywords","content":"MixCare Health"},{"name":"app-mobile-web-app-title","content":"MixCare Health"},{"name":"application-name","content":"MixCare Health"}],"link":[{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://portal.mixcarehealth.com/favicon/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://portal.mixcarehealth.com/favicon/favicon-32x32.png"},{"rel":"shortcut icon","href":"https://portal.mixcarehealth.com/favicon/favicon-32x32.png"}],"style":[],"script":[],"noscript":[],"titleTemplate":"%s","title":"MixCare Health - Asia's leading health & wellness digital platform"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'